export default "__VITE_ASSET__CNhRketC__"